var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.532,
    height: 43.117,
    viewBox: "0 0 35.532 43.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2677",
    "data-name": "Rectangle 2677",
    width: 35.532,
    height: 43.117,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M8.113,13.328a7.775,7.775,0,0,1-3.4-.072l-.988-.245L.718,18.225l.7.733a8.022,8.022,0,0,1,2.2,5.611v.071a7.984,7.984,0,0,1-2.2,5.585l-.706.733,3.011,5.214.987-.244a7.988,7.988,0,0,1,5.936.889l.061.035a8.029,8.029,0,0,1,3.761,4.71l.281.976h6.021l.282-.978a8.015,8.015,0,0,1,3.752-4.705l.027-.015.027-.016a8.017,8.017,0,0,1,5.95-.9l.989.245,3.01-5.214-.7-.732a8.031,8.031,0,0,1-2.2-5.612v-.071a7.989,7.989,0,0,1,2.2-5.585l.7-.733L31.8,13.011l-.987.245a7.849,7.849,0,0,1-4.066-.089",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M22.5,12.279l2.6,2.136a3.434,3.434,0,0,1,1.254,2.654v5.588a3.085,3.085,0,0,1-3.085,3.085",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M13.031,12.279l-2.6,2.136a3.434,3.434,0,0,0-1.254,2.654v5.588a3.085,3.085,0,0,0,3.085,3.085",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M12.408,17.9l-.015,1.831v6.017a5.372,5.372,0,1,0,10.744,0V19.734L23.125,17.9",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 5.399,
    cy: 5.399,
    r: 5.399,
    transform: "translate(12.367 0.578)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M27.8,25.3a10.037,10.037,0,0,1-20.074,0",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.157
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCust);
export default __webpack_public_path__ + "static/media/cust.a8edbf1f32798cca827837ae4bddd1fc.svg";
export { ForwardRef as ReactComponent };